<wlm-time-selector-chart
  [timeSelectorChartSetting]="timeSelectorChartSetting"
  [containerSize$]="size$"
></wlm-time-selector-chart>
